<template>
	<modal :withOkBtn="true" :withCancelBtn="true" @close="$emit('close')" @ok="createExperience">
		<div slot="header">Create a new experience</div>
		<div slot="body">
			<div  v-if="isSpacesEmpty" class="form-group">
				<div>You need to create a new space first</div>
			</div>
			<div v-else>
				<div class="form-group">
					<div class="form-label">Select a space:</div>
					<select-box :options="allSpaces" :placeholder="'Select space'" @change="updateSelectedSpace" :inputError="attemptSubmit && isChosenSpaceEmpty"></select-box>
					<div class="modal-message" v-if="attemptSubmit && isChosenSpaceEmpty">Please choose a space from the list</div>
				</div>
				<div class="form-group">
					<div class="form-label">Enter Experience Title:</div>
					<input type="text" name="experienceTitle" class="form-input" placeholder="Experience Title" v-model="title" @input="message = ''"
						:class="{'input-error': attemptSubmit && isTitleEmpty}">
					<div class="modal-message" v-if="attemptSubmit && isTitleEmpty">Please enter a title for your new experience.</div>
				</div>
			</div>
			<!-- <form method="#" enctype="multipart/form-data">
				<div class="form-group">
					<input type="file" ref="file" class="form-input" placeholder="Upload Files" accept="image/*" @change="onSelect">
				</div>
				<div class="form-group"><button>Submit</button></div>
			</form> -->
		</div>
	</modal>
</template>

<script>
	import Modal from './Modal'
	import SelectBox from '@/components/SelectBox'
	import axios from 'axios';
	import {mapGetters} from 'vuex';

	export default {
		name: 'CreateExperienceModal',
		components: {
			'modal': Modal,
			'selectBox': SelectBox
		},
		computed: {
			...mapGetters(['allSpaces']),
			isTitleEmpty: function() {
				return this.title == '';
			},
			isSpacesEmpty: function() {
				return this.allSpaces.length == 0;
			},
			isChosenSpaceEmpty: function() {
				return this.chosenSpace === '';
			},
			isValidInputs: function() {
				return !this.isTitleEmpty && !this.isChosenSpaceEmpty;
			}
		},
		data() {
			return {
				file: '',
				message: '',
				title: '',
				chosenSpace: '',
				attemptSubmit: false
			}
		},
		methods: {
			createExperience() {
				this.attemptSubmit = true;
				if (this.isValidInputs) {
					let newId = this.allSpaces[this.allSpaces.length-1].id + 1;
					let sceneObj = {
						id: newId,
						title: this.title,
						chosenSpace: this.allSpaces[this.chosenSpace],
						nodes: [],
						links: []
					};
					this.$emit('ok', sceneObj);
				} else if(this.isSpacesEmpty) {
					this.$emit('close');
				}
			},
			updateSelectedSpace(index) {
				this.chosenSpace = index;
			}
			// onSelect() {
			// 	const file = this.$refs.file.files[0];
			// 	this.file = file;
			// },
			// async onSubmit() {
			// 	console.log(this.file);
			// 	const formData = new FormData();
			// 	formData.append('file', this.file);
			// 	try {
			// 		await axios.post('http://192.168.1.144:5000/upload', formData);
			// 		this.message = 'Uploaded!!';
			// 		setTimeout(function(){
			// 			this.$emit('ok', this.title);
			// 		}.bind(this), 1000);
			// 	}
			// 	catch(err) {
			// 		console.log(err);
			// 		this.message = 'Something went wrong!!!';
			// 	}
			// }
		}
	}
</script>
